import { color } from 'framer-motion';
import { PieChart, Pie, Tooltip, Legend ,Cell} from 'recharts';



const ReportsPie = ({statsData}) => {
  console.log(statsData)
  const data = [
    { name: 'assigned_assets', value: statsData.assigned_assets, color: '#006769' },
    { name: 'lost_assets', value: statsData.lost_assets, color: '#40A578' },
    { name: 'retired_assets', value: statsData.retired_assets, color: '#FF5F00' },
    { name: 'total_assets', value: statsData.total_assets, color: '#E6FF94' },
    { name: 'unassigned_assets', value: statsData.unassigned_assets, color: '#FFBB28' },
  ];
  return (
  <PieChart width={380} height={300}>
    <Pie
      data={data}
      cx={200}
      cy={150}
      innerRadius={60}
      outerRadius={80}
      dataKey="value"
      nameKey="name"
      label
    >
      {data.map((entry, index) => (
        <Cell key={`cell-${index}`} fill={entry.color} />
      ))}
    </Pie>
    <Tooltip  />
    <Legend color='#fff' fill='#fff' />
  </PieChart>
  )
  };

export default ReportsPie;
